
import {myConfig} from '../config/myConfig'
import React from 'react'
import Paper from 'material-ui/Paper'
import {
  Table,
  TableBody,
  TableHeader,
  TableHeaderColumn,
  TableRow,
  TableRowColumn,
} from 'material-ui/Table'
import moment from 'moment'
import 'moment/locale/fr'
const styles= {}



class MonthView extends React.Component {





  render() {
    return (

      <Paper zDepth={3} style={{
        overflowX: 'scroll',
        WebkitOverflowScrolling: 'touch',
        height:'100%',
        padding:0,marginTop:10}}>
        <div id="pdf">
        <Table
          style={{margin:0,padding:0,boxSizing:'border-box',minWidth:'600px',}}
          wrapperStyle={{minWidth:'600px',boxSizing:'border-box',}}
          fixedHeader={true}
          selectable={false}
          multiSelectable={false}>

          <TableHeader
            style={styles.row}
            displaySelectAll={false}
            adjustForCheckbox={false}
            enableSelectAll={false} >
            <TableRow>
              <TableHeaderColumn style={{...styles.row,width:'130px',textAlign:'left'}}>Date Gregorian</TableHeaderColumn>
              <TableHeaderColumn style={{...styles.row,width:'100px',textAlign:'right'}}>Date Hijri</TableHeaderColumn>
              <TableHeaderColumn style={styles.row}>Fajr</TableHeaderColumn>
              <TableHeaderColumn style={styles.row}>Shuruq</TableHeaderColumn>
              <TableHeaderColumn style={styles.row}>Dhohr</TableHeaderColumn>
              <TableHeaderColumn style={styles.row}>Asr</TableHeaderColumn>
              <TableHeaderColumn style={styles.row}>Maghrib</TableHeaderColumn>
              <TableHeaderColumn style={styles.row}>Isha</TableHeaderColumn>
              <TableHeaderColumn style={{...styles.row,fontSize:10}}>Moitié<br/>de la nuit</TableHeaderColumn>
            {/* <TableHeaderColumn style={{...styles.row,fontSize:10}}>Début du<br/>dernier <br/>tiers</TableHeaderColumn> */}
            </TableRow>
          </TableHeader>

          <TableBody
            displayRowCheckbox={false}
            deselectOnClickaway={false}
            showRowHover={false}
            stripedRows={true}>

            {this.props.dataMonthView.dates.map((date,i)=>
              <TableRow
                displayBorder={false}
                key={i} style={{...styles.row,
                  backgroundColor: moment(new Date()).format('D MMMM YYYY') === date.gregorian_date ? myConfig.green : date.today === 'Vendredi' ? myConfig.blue: '',
                  color: moment(new Date()).format('D MMMM YYYY') === date.gregorian_date ?'white': date.today === 'Vendredi' ? 'white': ''}}>

                <TableRowColumn style={{...styles.row,width:'150px',textAlign:'left'}}>{date.today} {date.gregorian_date}</TableRowColumn>
                <TableRowColumn style={{...styles.row,width:'90px',textAlign:'right'}}>{date.hijri_date}</TableRowColumn>
                <TableRowColumn style={styles.row}>{date.times[0].time}</TableRowColumn>
                <TableRowColumn style={styles.row}>{date.times[1].time}</TableRowColumn>
                <TableRowColumn style={styles.row}>{date.times[2].time}</TableRowColumn>
                <TableRowColumn style={styles.row}>{date.times[3].time}</TableRowColumn>
                <TableRowColumn style={styles.row}>{date.times[4].time}</TableRowColumn>
                <TableRowColumn style={styles.row}>{date.times[5].time}</TableRowColumn>
                <TableRowColumn style={styles.row}>{date.times[6].time}</TableRowColumn>
                {/* <TableRowColumn style={styles.row}>{date.times[7].time}</TableRowColumn> */}

              </TableRow>
            )}

          </TableBody>
        </Table>
        </div>
      </Paper>

    )
  }
}

styles.row ={
  height:18,padding:'2px 2px 0 2px', fontSize:11,textAlign:'center',
}

export default MonthView



// WEBPACK FOOTER //
// ./src/components/MonthView.jsx